<script setup>
import { useRoute } from '@/Utils/useRoute';
const route = useRoute();

import { Link } from '@inertiajs/vue3';
import CookieConsent from '@/Components/CookieConsent.vue';
</script>

<template>
  <footer class="footer bg-dark text-white py-5">
    <div class="container">
      <div class="row">
        <!-- Company Info -->
        <div class="col-md-4 mb-4 mb-md-0">
          <div class="d-flex align-items-center mb-3">
            <span class="brand-first">Price</span><span class="font-weight-bold">Compare</span>
          </div>
          <p class="text-light mb-3">
            Find de bedste tilbud og sammenlign priser på produkter fra forskellige butikker i Danmark.
          </p>
          <div class="social-links">
            <!--<a href="#" class="me-3 text-light"><i class="bi bi-facebook"></i></a>
            <a href="#" class="me-3 text-light"><i class="bi bi-twitter"></i></a>
            <a href="#" class="me-3 text-light"><i class="bi bi-instagram"></i></a>
            <a href="#" class="text-light"><i class="bi bi-linkedin"></i></a>-->
          </div>
        </div>
        
        <!-- Quick Links -->
        <div class="col-md-2 col-6 mb-4 mb-md-0">
          <h5 class="text-uppercase mb-3 footer-title">Links</h5>
          <ul class="list-unstyled">
            <li class="mb-2"><Link :href="route('frontpage')" class="text-light text-decoration-none">Forside</Link></li>
            <li class="mb-2"><Link :href="route('products')" class="text-light text-decoration-none">Produkter</Link></li>
            <li class="mb-2"><Link :href="route('categories')" class="text-light text-decoration-none">Kategorier</Link></li>
            <li class="mb-2"><Link :href="route('articles')" class="text-light text-decoration-none">Artikler</Link></li>
          </ul>
        </div>
        
        <!-- Support -->
        <div class="col-md-2 col-6 mb-4 mb-md-0">
          <h5 class="text-uppercase mb-3 footer-title">Support</h5>
          <ul class="list-unstyled">
            <li class="mb-2"><Link :href="route('contact')" class="text-light text-decoration-none">Kontakt os</Link></li>
            <li class="mb-2"><Link :href="route('faq')" class="text-light text-decoration-none">FAQ</Link></li>
            <li class="mb-2"><Link :href="route('terms')" class="text-light text-decoration-none">Vilkår</Link></li>
            <li class="mb-2"><Link :href="route('privacy')" class="text-light text-decoration-none">Privatpolitik</Link></li>
            <li class="mb-2"><Link :href="route('cookie.preferences')" class="text-light text-decoration-none">Cookie indstillinger</Link></li>
          </ul>
        </div>
        
        <!-- Contact Info -->
        <div class="col-md-4 mb-4 mb-md-0">
          <h5 class="text-uppercase mb-3 footer-title">Kontakt</h5>
          <ul class="list-unstyled contact-info">
            <li class="mb-2"><i class="bi bi-geo-alt me-2"></i> Nykøbing F., Danmark</li>
            <li class="mb-2"><i class="bi bi-envelope me-2"></i> info@pricecompare.dk</li>
          </ul>
          
          <!-- Newsletter (optional) -->
          <div class="mt-4">
            <h6 class="mb-2">Tilmeld nyhedsbrev</h6>
            <div class="input-group">
              <input type="email" class="form-control" placeholder="Din email">
              <button class="btn btn-pricecompare-secondary" type="button">Tilmeld</button>
            </div>
          </div>
        </div>
      </div>
      
      <hr class="mt-4 mb-4 bg-secondary">
      
      <!-- Bottom Footer -->
      <div class="row align-items-center">
        <div class="col-md-6 text-center text-md-start mb-3 mb-md-0">
          <p class="mb-0">&copy; {{ new Date().getFullYear() }} PriceCompare.dk. Alle rettigheder forbeholdes.</p>
        </div>
        <div class="col-md-6 text-center text-md-end">
          <CookieConsent class="d-inline-block" />
        </div>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.footer {
  background-color: #1E3A8A !important;
}

.footer-title {
  font-size: 1rem;
  font-weight: 600;
  color: #FF5733;
}

.brand-first {
  color: #FF5733;
  font-weight: 700;
  font-size: 1.3rem;
}

.btn-pricecompare-secondary {
  background-color: #FF5733;
  border-color: #FF5733;
  color: white;
}

.btn-pricecompare-secondary:hover {
  background-color: #E64A19;
  border-color: #E64A19;
  color: white;
}

.social-links a {
  font-size: 1.2rem;
  transition: color 0.2s;
}

.social-links a:hover {
  color: #FF5733 !important;
}

.contact-info i {
  color: #FF5733;
}
</style>
